import ResourceController from 'Root/helpers/ResourceController';
import { mutateEntity, mutateNestedEntity } from 'Root/store/components/commonMutations';

export default {
  state() {
    return {
      headerInfo: '',
      isLoading: false,
      searchBlogResults: {},
      searchProductsResults: {},
      requestOptions: {},
      visibleCards: {},
    };
  },

  mutations: {
    mutateEntity,

    mutateNestedEntity,
  },

  actions: {
    getSearchAllBlog({ state, dispatch }) {
      const { requestOptions } = state;

      const allRequests = Object.keys(requestOptions)
        .map((cards) => dispatch('getSearchBlog', { nestedEntity: cards, isClearedOldResults: true }));

      return Promise.allSettled(allRequests);
    },

    getSearchBlog({ state, commit, dispatch }, { nestedEntity, isClearedOldResults = false }) {
      commit('mutateEntity', { entity: 'isLoading', data: true });

      let url;
      const { requestOptions } = state;

      switch (nestedEntity) {
        case 'articles':
          url = 'blog_posts/list';
          break;

        case 'products':
          url = 'product/list';
          break;

        default:
          console.log('No find url');
      }

      return ResourceController.getResources(url, requestOptions[nestedEntity])
        .then(({ data }) => {
          if (isClearedOldResults) {
            commit('mutateNestedEntity', {
              entity: 'searchBlogResults',
              nestedEntity,
              data: {},
            });
          }

          dispatch('setSearchData', { entity: 'searchBlogResults', nestedEntity, data });
        })
        .catch((data) => {
          console.log(data);
        })
        .finally(() => commit('mutateEntity', { entity: 'isLoading', data: false }));
    },

    getSearchAllProduct({ dispatch }, { search, region }) {
      return dispatch('getSearchProduct', { search, region, isClearedOldResults: true });
    },

    getSearchProduct({ state, dispatch, commit }, {
      search, region, gameId = null, isClearedOldResults = false,
    }) {
      commit('mutateEntity', { entity: 'isLoading', data: true });

      const params = {
        search,
        region,
        params_by_game: gameId ? { [gameId]: state.requestOptions[gameId] } : state.requestOptions,
      };

      return ResourceController.getResources('product/search', params)
        .then(({ data }) => {
          Object.keys(data.result).forEach((_gameId) => {
            if (isClearedOldResults) {
              commit('mutateNestedEntity', {
                entity: 'searchProductsResults',
                nestedEntity: _gameId,
                data: {},
              }); /* Очищаем предыдущие результаты поиска */
            }

            dispatch('setSearchData', {
              entity: 'searchProductsResults',
              nestedEntity: _gameId,
              data: data.result[_gameId],
            });
          });
        })
        .catch(({ data }) => {
          console.log(data);
        })
        .finally(() => commit('mutateEntity', { entity: 'isLoading', data: false }));
    },

    setSearchData({ commit, state }, { entity, nestedEntity, data }) {
      if (!data.result) {
        return;
      }

      if (state.requestOptions[nestedEntity].offset === 0) {
        commit('mutateNestedEntity', { entity, nestedEntity, data });
      } else {
        const newData = {
          ...state[entity][nestedEntity],
          result: [
            ...state[entity][nestedEntity].result,
            ...data.result,
          ],
        };

        commit('mutateNestedEntity', { entity, nestedEntity, data: newData });
      }
    },
  },

  namespaced: true,
};
